export enum MapLayerIDs {
  ROADMAP = 'roadmap',
  HYBRID = 'hybrid',
  TERRAIN = 'terrain',
}

export enum MapLayersOptionsTooltips {
  "mapStyleOptions" = "enums.staticData.mapLayersOptionsTooltips.mapStyleOptions",
  "overlayAndStations" = "enums.staticData.mapLayersOptionsTooltips.overlayAndStations"
}

export enum MapLayersSubTitles {
  overlay = "enums.staticData.mapLayersSubTitles.overlay",
  stations = "enums.staticData.mapLayersSubTitles.stations",
  weather = "enums.staticData.mapLayersSubTitles.weather",
}

export const MapLayers = [
  {
    id: 'default',
    title: 'enums.staticData.mapLayers.default',
    icon: 'layers',
    alt: 'Roadmap',
    selected: false,
  },
  {
    id: 'roadmap',
    title: 'enums.staticData.mapLayers.roadmap',
    icon: 'traffic-cone',
    showLayers: false,
    alt: 'Roadmap',
    selected: false,
  },
  {
    id: 'hybrid',
    title: 'enums.staticData.mapLayers.satellite3D',
    icon: 'satellite-dish',
    alt: 'Roadmap',
    selected: false,
  },
  {
    id: 'terrain',
    title: 'enums.staticData.mapLayers.terrain',
    icon: 'mountain',
    alt: 'Roadmap',
    selected: false,
  },
];

export const MapOptions = [
  {
    id: 'traffic',
    title: 'enums.staticData.mapOptions.traffic',
    selected: false,
  },
  {
    id: 'fleetClustering',
    title: 'enums.staticData.mapOptions.fleetClustering',
    selected: false,
  },
];

export const MapMarkers = [
  {
    id: 'weighStations',
    title: 'enums.staticData.mapMarkers.weighStations',
    selected: false,
  },
  {
    id: 'catScale',
    title: 'enums.staticData.mapMarkers.catScale',
    selected: false,
  },
  // {
  //   id: 'gpsPilot',
  //   title: 'enums.staticData.mapMarkers.gpsPilot',
  //   selected: false,
  // },
  {
    id: 'loves',
    title: 'enums.staticData.mapMarkers.loves',
    selected: false,
  },
  {
    id: 'travelCentersAmerica',
    title: 'enums.staticData.mapMarkers.travelCentersAmerica',
    selected: false,
  },
];

export const MapMarkersWithGPSpilot = [
  {
    id: 'weighStations',
    title: 'enums.staticData.mapMarkers.weighStations',
    selected: false,
  },
  {
    id: 'catScale',
    title: 'enums.staticData.mapMarkers.catScale',
    selected: false,
  },
  {
    id: 'gpsPilot',
    title: 'enums.staticData.mapMarkers.gpsPilot',
    selected: false,
  },
  {
    id: 'loves',
    title: 'enums.staticData.mapMarkers.loves',
    selected: false,
  },
  {
    id: 'travelCentersAmerica',
    title: 'enums.staticData.mapMarkers.travelCentersAmerica',
    selected: false,
  },
];


export const WeatherLayers = [
  {
    id: 'temperature',
    title: 'enums.staticData.weatherLayers.temperature',
    selected: false,
  },
  {
    id: 'clouds',
    title: 'enums.staticData.weatherLayers.clouds',
    selected: false,
  },
  {
    id: 'wind',
    title: 'enums.staticData.weatherLayers.wind',
    selected: false,
  },
  {
    id: 'rain',
    title: 'enums.staticData.weatherLayers.rain',
    selected: false,
  },
  {
    id: 'snow',
    title: 'enums.staticData.weatherLayers.snow',
    selected: false,
  },
];
